import { render, staticRenderFns } from "./Project5Zh.vue?vue&type=template&id=b3ce6d80&scoped=true&"
import script from "./Project5Zh.vue?vue&type=script&lang=js&"
export * from "./Project5Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project5Zh.vue?vue&type=style&index=0&id=b3ce6d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ce6d80",
  null
  
)

export default component.exports